import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "shared/utils/constants/queryKeys";
import ReactTable from "react-table";
import { useHistory } from "react-router-dom";
import { generatePath } from "react-router";
import routes from "shared/utils/constants/routes";
import Modal from "views/components/modal/modal";
// Styles
import "react-table/react-table.css";
import styles from "./styles-list.module.scss";
import themeStyles from "shared/styles/theme/theme-styles.module.scss";
// Icons
import DeleteIco from "shared/images/delete.svg";
import EditIco from "shared/images/edit.svg";
import CloseIco from "shared/images/close-modal.svg";
import { deleteTheme, getAllThemes } from "services/publicLiveScores";

const NoData = ({ label, loading, ...rest }) => (
  <div className={styles.noTableData} {...rest}>
    {loading ? <h3>Loading...</h3> : <h3>No themes yet</h3>}
  </div>
);

const ThemesList = () => {
  const history = useHistory();
  const [deleteThemeId, setDeleteThemeId] = useState(null);

  // useQuery to get all themes
  const { loading, data = [] } = useQuery({
    queryKey: [queryKeys.themes.getAllThemes, deleteThemeId],
    queryFn: () => getAllThemes(),
    refetchOnWindowFocus: false,
  });

  // Table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "theme_id",
        headerClassName: styles.header,
        maxWidth: 98,
        className: styles.cell,
        getProps: (_, rowInfo) => ({
          onClick: () => console.log(rowInfo?.original),
        }),
      },
      {
        Header: "Theme name",
        accessor: "theme_name",
        headerClassName: styles.header,
        className: styles.cell,
        Cell: ({ value }) => <span>{value}</span>,
        getProps: (_, rowInfo) => ({
          onClick: () => console.log(rowInfo?.original),
        }),
      },
      {
        Header: "",
        accessor: "theme_id",
        headerClassName: styles.header,
        className: styles.cell,
        maxWidth: 100,
        Cell: ({ value }) => (
          <div className={styles.actions}>
            <button
              className={styles.btnEdit}
              onClick={() =>
                history.push(generatePath(routes.Themes.EDIT, { id: value }))
              }
            >
              <img src={EditIco} alt="edit icon" />
            </button>
            <button
              className={styles.btnDelete}
              onClick={() => setDeleteThemeId(value)}
            >
              <img src={DeleteIco} alt="delete icon" />
            </button>
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <div className={styles.container}>
      <div className={styles.lines} />

      <div className={styles.tableContainer}>
        <button
          className={styles.btnNew}
          onClick={() => history.push("/settings-themes/new")}
        >
          New theme
        </button>
        <ReactTable
          data={data}
          columns={columns}
          showPagination={false}
          sortable={false}
          minRows={data.length || 4}
          defaultPageSize={Number.MAX_VALUE}
          NoDataComponent={(props) => <NoData {...props} loading={loading} />}
          className={styles.table}
        />
      </div>

      {!!deleteThemeId && (
        <Modal
          title="Delete theme"
          text="Are you sure you want to delete this theme?"
          onClose={() => setDeleteThemeId(false)}
          onConfirm={() => setDeleteThemeId(false)}
          width={543}
        >
          <div style={{ position: "relative" }}>
            <button
              className={`${styles.modalDeleteBtnClose}`}
              onClick={() => setDeleteThemeId(false)}
            >
              <img
                src={CloseIco}
                alt="close modal icon"
                onClick={() => setDeleteThemeId(false)}
              />
            </button>

            <h2 className={styles.modalDeleteTitle}>
              Are you sure you want to delete this theme?
            </h2>

            <div className={styles.modalDeleteActions}>
              <button
                className={themeStyles.btnOutlinedExpandable}
                onClick={() => setDeleteThemeId(null)}
              >
                Cancel
              </button>
              <button
                className={themeStyles.btnDanger}
                onClick={() =>
                  deleteTheme(deleteThemeId).then(() => {
                    setDeleteThemeId(null);
                  })
                }
              >
                Delete theme
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ThemesList;
